import { Link } from "react-router-dom";
import "../Styles/Card.css";
import type { MapFeedItemDTO } from "../data/types";
import { venuePath } from "../utils/routes";
import VenueCheckIn from "./VenueCheckIn";
import VenueNowPlaying from "./Venue/VenueNowPlaying";
import VenueSummary from "./Venue/VenueSummary";

type CardProps = {
  item: MapFeedItemDTO;
};

export default function MapCard({ item }: CardProps) {
  const noLiveData = item.hasLiveData === false;

  const recentTracks = item.previouslyPlayed ?? [];
  const rollingTracks = [...recentTracks, ...recentTracks];

  return (
    <div className={`card-wrapper card-venue${noLiveData ? " card-venue--no-live" : ""}`}>
      <VenueSummary item={item} />

      <VenueNowPlaying item={item} />

      {!noLiveData && rollingTracks.length > 0 && (
        <div className="card-bottom">
          <div className="interact-item">
            <span className="text-damp">Just played:</span>
          </div>

          <div className="rolling-item">
            <div className="rolling-track">
              {rollingTracks.map((song, index) => (
                <span key={`${song.id}-${index}`} className="rolling-chip text-damp">
                  {song.title} - {song.artist}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Kortet är ett utdrag. Stället själv — historik, vägbeskrivning,
          vilka som är där — bor på sin egen sida. */}
      <Link className="venue-page-link" to={venuePath(item.venue.id)}>
        Venue page ›
      </Link>

      <VenueCheckIn venueId={item.venue.id} venueName={item.venue.name} />
    </div>
  );
}
